export default __webpack_public_path__ + "static/media/borderDark2Light.67a03c5c.svg";